<script lang="ts">
    
    import type { Player } from "../../Model/Player";
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Shared/Watch.svelte";

    export let player: Player;
    export let invert = false;

    const darkColor = '#333';
    const lightColor = '#eee';

    let bgColor: string;
    let color: string;

    $: if (invert) {
        bgColor = lightColor;
        color = darkColor;
    } else {
        bgColor = darkColor;
        color = lightColor;
    }

</script>

<div class="player-bar" {...$$restProps} style="--bg-color: {bgColor}; --color: {color};">
    <div class="picture">
        <Picture id={player.pictureId} />
    </div>
    <div class="name">
        <Watch state={player.name} />
    </div>
</div>

<style lang="scss">

    .player-bar {
        display: flex;
        align-items: center;
        gap: 1rem;
        background-color: var(--bg-color);
        color: var(--color);
        padding: .5rem 1rem .5rem .5rem;
        border-radius: 1000rem;
    }

    .picture {
        $size: 50px;
        width: $size;
        height: $size;
        border-radius: 50%;
        overflow: hidden;
    }

    .name {
        flex: 1 1 0;
        font-size: 1.6rem;
    }

</style>
